/* eslint-disable react/jsx-props-no-spreading */

// Utils
import cn from '../../../utils/cn';

// Stylew
import styles from './Switch.module.css';

/**
 * Switch component - A toggle switch input with optional label
 * @param {object} params
 * @param {string} params.name - Required name attribute for the input
 * @param {string} params.id - Required unique identifier for the switch
 * @param {boolean} [params.checked=false] - Whether switch is checked
 * @param {(checked: boolean) => void} [params.onChange] - Callback when switch state changes
 * @param {boolean} [params.disabled=false] - Whether switch is disabled
 * @param {string} [params.className=''] - Additional CSS classes
 * @param {string} [params.label] - Text label for the switch
 * @param {'small'|'large'} [params.size='large'] - Switch size
 * @param {object} [params.props] - Additional props to spread on the input
 * @returns {JSX.Element} Switch component
 */
function Switch({
  name,
  id,
  checked = false,
  onChange,
  disabled = false,
  className = '',
  label,
  size = 'large',
  ...props
}) {
  const triggerSwitch = () => {
    if (disabled) {
      return;
    }

    if (typeof onChange === 'function') {
      onChange(!checked);
    }
  };

  return (
    <div className={cn([className, styles['switch-wrapper'], styles[size], 'ui-switch__wrapper'])}>
      <button
        type="button"
        onClick={triggerSwitch}
        className={cn([
          styles.switch,
          checked ? styles['switch-checked'] : null,
          disabled ? styles['switch-disabled'] : null,
        ])}
      >
        <div className={cn([styles['switch-container']])} />
        <div className={cn([styles['switch-circle']])} />
        <input
          id={id}
          name={name}
          checked={checked}
          onChange={triggerSwitch}
          type="checkbox"
          className={cn([styles['switch-input']])}
          {...props}
        />
      </button>
      {label ? (
        <label
          htmlFor={id}
          className={cn([styles['switch-label']])}
        >
          {label}
        </label>
      ) : null}
    </div>
  );
}

export default Switch;
